import React from 'react'
import { useNavigate } from 'react-router-dom'

export default function Emptycart() {
  const navigate = useNavigate();

  // const handleStartShopping = () => {
  //   navigate('/');
  // };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4">
      <div className="max-w-md w-full rounded-lg p-8 text-center">
        {/* Empty Cart Icon */}
        <div className="mb-6">
          <div className="w-24 h-24 mx-auto bg-red-50 rounded-full flex items-center justify-center">
            <svg 
              className="w-12 h-12 text-red-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={1} 
                d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" 
              />
            </svg>
          </div>
        </div>

        {/* Content */}
        <div className="space-y-4">
          <h1 className="text-2xl font-bold text-gray-900">
            Your Shopping Cart is Empty
          </h1>
          
          <p className="text-gray-600 text-base leading-relaxed">
            Discover our wide selection of quality products. From fresh groceries to household essentials, 
            we have everything you need for your daily life.
          </p>

          {/* Additional Options */}
          <div className="mt-6 pt-4 border-t border-gray-100">
            <div className="flex justify-center space-x-4 text-sm">
              <button 
                onClick={() => navigate('/search-items')}
                className="text-red-600 hover:text-red-700 font-medium transition-colors duration-200"
              >
                Search Products
              </button>
              <span className="text-gray-300">|</span>
              <button 
                onClick={() => navigate('/')}
                className="text-gray-600 hover:text-gray-800 font-medium transition-colors duration-200"
              >
                Continue Shopping
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
